export default function Hover({children, description}) {
    return <div className="relative group w-fit">
        {children}

        <div className="absolute bottom-full mb-2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 bg-zinc-800 text-white text-sm px-2 py-1 rounded pointer-events-none">
            {description}
        </div>
    </div>
}